import { Button, TextField, Tooltip } from '@mui/material'
import { useRecordContext } from 'react-admin'

// allowed users - harry, jez, nick t, ryan, keith
const ALLOWED_USER_IDS = new Set(['1', '2', '7', '17', '1240'])
const ALLOWED_ROLES = ['ROLE_ADMIN', 'ROLE_SALVAGE']

const CapFields = () => {
  const record = useRecordContext()
  const user_id = localStorage.getItem('user_id')
  const roles = (localStorage.getItem('permissions') || '').split(',')
  const showCapValueField =
    ALLOWED_ROLES.some((role) => roles.includes(role)) ||
    ALLOWED_USER_IDS.has(user_id)

  if (!showCapValueField) return null

  const capHistory = record.leadContact.vehicle.vehicleCapHistory ?? []
  const vehicleCap = capHistory[capHistory.length - 1] ?? null

  const tooltipData = vehicleCap
    ? [
        { name: 'Average', value: vehicleCap.average },
        { name: 'Clean', value: vehicleCap.clean },
        { name: 'Retail', value: vehicleCap.retail },
      ]
    : []

  return (
    <>
      <Tooltip
        title={
          tooltipData &&
          tooltipData.map((tip) => (
            <div key={tip.name} style={{ fontSize: '12px', padding: '2px' }}>
              <div style={{ width: '60px', display: 'inline-block' }}>
                {tip.name}:
              </div>
              <div style={{ display: 'inline-block' }}>{tip.value}</div>
            </div>
          ))
        }
      >
        <TextField label="Cap Value" disabled value={vehicleCap?.value ?? ''} />
      </Tooltip>
    </>
  )
}

export default CapFields
